/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdentityError } from './IdentityError';
import {
    IdentityErrorFromJSON,
    IdentityErrorFromJSONTyped,
    IdentityErrorToJSON,
    IdentityErrorToJSONTyped,
} from './IdentityError';

/**
 * 
 * @export
 * @interface IdentityResult
 */
export interface IdentityResult {
    /**
     * 
     * @type {boolean}
     * @memberof IdentityResult
     */
    readonly succeeded?: boolean;
    /**
     * 
     * @type {Array<IdentityError>}
     * @memberof IdentityResult
     */
    readonly errors?: Array<IdentityError> | null;
}

/**
 * Check if a given object implements the IdentityResult interface.
 */
export function instanceOfIdentityResult(value: object): value is IdentityResult {
    return true;
}

export function IdentityResultFromJSON(json: any): IdentityResult {
    return IdentityResultFromJSONTyped(json, false);
}

export function IdentityResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityResult {
    if (json == null) {
        return json;
    }
    return {
        
        'succeeded': json['succeeded'] == null ? undefined : json['succeeded'],
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(IdentityErrorFromJSON)),
    };
}

export function IdentityResultToJSON(json: any): IdentityResult {
    return IdentityResultToJSONTyped(json, false);
}

export function IdentityResultToJSONTyped(value?: Omit<IdentityResult, 'succeeded'|'errors'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

